// extracted by mini-css-extract-plugin
export default {"triangle":"triangle_triangle__FpGbQ","triangle--rotated":"triangle_triangle--rotated__uv7hP"};